/** @format */

import React, { useEffect, useState } from "react"
import {
	FilterBarWrapper,
	StyledBadge,
	LeftContainer,
	RightContainer,
} from "./DashBoardFilterBar.styled"

import SearchButton from "_components/atoms/SearchButton/SearchButton"
import { DashBoardFilterBarProps } from "./DashBoardFilterBar.types"
import ButtonExportCsv from "../ButtonExportCsv/ButtonExportCsv"
import { Badge } from "@ui-library/core"
import { DistributionChangeType } from "../CreditDispatchTable/CreditDispatchTable.types"

const DashBoardFilterBar = (props: DashBoardFilterBarProps) => {
	const { availableCreditsCount, searchTerm, handleSearch, isLoading, distributionChangeType } = props

	return (
		<FilterBarWrapper 
			isLoading={isLoading}>
			<LeftContainer>
				<SearchButton
					placeholder="Rechercher par ID RCU, ID parte.."
					value={searchTerm ?? ""}
					handleSearch={e => handleSearch(e.target.value)}
				/>
				<StyledBadge label={`${availableCreditsCount} ${availableCreditsCount <= 1 ? 'boost disponible' : 'boosts disponibles'}`} />
				<div>
					{
						distributionChangeType == DistributionChangeType.ALL
						 && <Badge testID="distrib-new-all" label={`Vos modifications sont en attentes`} kind="contacted" />
					}
					{
						distributionChangeType == DistributionChangeType.ALLOCATED_BOOST
						 && <Badge testID="distrib-new-boost" label={`Vos boosts sont en cours d'affectation`} kind="contacted" />
					}
					{
						distributionChangeType == DistributionChangeType.DISTRIBUTION_MODE
						 && <Badge testID="distrib-new-mode" label={`Vos changements de mode sont en cours de traitement`} kind="contacted" />
					}
				</div>
			</LeftContainer>
			<RightContainer>
				<ButtonExportCsv />
			</RightContainer>
		</FilterBarWrapper>
	)
}

export default DashBoardFilterBar
